import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {restoreAccount} from 'src/openapi/admin/apis/UpdateAccountApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRestoreAccount = ({accountId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        restoreAccount({accountId}),
    ), [accountId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
